import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Empty from '@fmbt/ui/Empty';
import { Gallery } from '@fmbt/ui/layout';
import PageHeaderPusher from 'components/atoms/PageHeaderPusher';
import OperationCard from 'components/cards/OperationCard';
import BackOfficeIPCameraAddDrawer from 'components/drawers/BackOfficeIPCameraAddDrawer';
import FarmbotSecurityCameraIcon from 'components/icons/FarmbotSecurityCameraIcon';
import IntegrationIcon from 'components/icons/IntegrationIcon';
import { ErrorBoundary } from 'config/sentry';
import { SEARCH_PARAMS } from 'constants/search-params';
import { useMyUserHasInternalPermission } from 'store/modules/myUser/hooks';
import { ProtectedResource, ResourceAction } from 'types/action.enum';
import { useReadyFlag } from 'utils/useReadyFlags';

function BackOfficeOperations() {
  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();
  const enableSelfServeDataTransfer = useReadyFlag('enableSelfServeDataTransfer');

  const canProvisionIPCameras = useMyUserHasInternalPermission({
    resource: ProtectedResource.IP_CAMERA,
    action: ResourceAction.ADD
  });

  const openIPCameraAddDrawer = () => {
    setSearchParams((prev) => {
      const newSearchParams = new URLSearchParams(prev);
      newSearchParams.set(SEARCH_PARAMS.DRAWER.key, SEARCH_PARAMS.DRAWER.values.ADD_IP_CAMERA);
      return newSearchParams;
    });
  };

  const operations = [
    ...enableSelfServeDataTransfer ? [{
      title: 'Data transfer',
      onClick: () => {
        navigate('/back-office/operations/data-transfer');
      },
      Icon: IntegrationIcon,
      caption: 'Transfer sample data from an old sensor to a new one'
    }] : [],
    ...canProvisionIPCameras ? [
      {
        title: 'Add IP Camera',
        onClick: openIPCameraAddDrawer,
        caption: 'For Farmbot Security Cameras manufactured by Land Watch',
        Icon: FarmbotSecurityCameraIcon
      }
    ] : []
  ];

  return (
    <ErrorBoundary>
      <PageHeaderPusher ds enterpriseScoped={false}>
        <BackOfficeIPCameraAddDrawer />
        {operations.length === 0 ? (
          <Empty description="No allowed operations" />
        ) : (
          <Gallery>
            {operations.map((operation, index) => (
              <OperationCard
                key={index}
                title={operation.title}
                caption={operation.caption}
                Icon={operation.Icon}
                onClick={operation.onClick}
              />
            ))}
          </Gallery>
        )}
      </PageHeaderPusher>
    </ErrorBoundary>
  );
}

export default BackOfficeOperations;
